































import Vue from 'vue'
import Input from '@/components/shared/atoms/Input'
import FaqList from '@/components/shared/molecules/List/Faq'
import Button from '@/components/shared/atoms/Button/Button'
import LoadingDot from '@/components/shared/atoms/LoadingDot'
import SearchFAQContentUseCase from '@/usecases/faq/SearchFAQContentUseCase'
import FaqSearchValidator, { Fields, FieldErrors } from '@/utils/validators/form/Support/Search'
import { extractTargetFields } from '@/utils/helper'
import { IFAQContentProps } from '@/entities/FAQContent'

interface IData {
  fields: Fields
  enableCheckFlg: { [key in keyof Fields]: boolean }
  searchedQuery: string | null
  isSearching: boolean
  searchResult: IFAQContentProps[]
  isComposing: boolean
  isLoading: boolean
}

export default Vue.extend({
  components: {
    Input,
    FaqList,
    Button,
    LoadingDot
  },
  data(): IData {
    return {
      fields: {
        query: null
      },
      enableCheckFlg: {
        query: false
      },
      searchedQuery: null,
      isSearching: false,
      searchResult: [],
      isComposing: false,
      isLoading: false
    }
  },
  computed: {
    formatSearchResult(): IFAQContentProps[] {
      // 入力した文字列がtitleまたはlabelNamesに含まれているものだけを抽出
      return this.searchResult.filter(r => {
        if (r.labelNames) return r.title.includes(this.searchedQuery as string) || r.labelNames.includes(this.searchedQuery as string)
      })
    },
    formErrors(): FieldErrors {
      const targetFields = extractTargetFields(this.fields, this.enableCheckFlg)
      return FaqSearchValidator.validate(targetFields)
    },
    hasError(): boolean {
      return !!this.formErrors.query.length
    },
    isNoResults(): boolean {
      return !!this.searchedQuery && !this.formatSearchResult.length
    },
    searchHit(): IFAQContentProps | undefined {
      return this.searchResult.find(r => r.title === this.fields.query)
    },
    canSubmit(): boolean {
      return !!this.fields.query && !this.hasError
    }
  },
  watch: {
    'fields.query': {
      immediate: true,
      async handler(val: IData['fields']['query']) {
        if (val) {
          await this.search()
        }
      }
    },
    isSearching: {
      async handler(val: IData['isSearching']) {
        // 検索クエリが入力値と異なる場合に再実行
        if (!val && this.fields.query && this.fields.query !== this.searchedQuery) {
          await this.search()
        }
      }
    }
  },
  mounted() {
    const el = document.getElementById('searchBox') as HTMLElement
    if (el) el.focus()
    // スマホのキーボードをtouchmove（スクロール）で閉じる
    const searchWindow = this.$refs['searchWindow'] as Element
    if (searchWindow) {
      searchWindow.addEventListener('touchmove', this.handleScroll)
    }
  },
  destroyed() {
    const searchWindow = this.$refs['searchWindow'] as Element
    if (searchWindow) {
      searchWindow.removeEventListener('touchmove', this.handleScroll)
    }
  },
  methods: {
    showResult() {
      if (!this.canSubmit) return
      this.$router.push({ path: '/support/search', query: { searchWord: this.fields.query } })
      if (this.$route.path === '/support/search') this.$emit('reSearch')
    },
    async search() {
      await this.enableCheck('query')
      const query = this.fields.query
      if (!query || this.isSearching || this.hasError) {
        this.searchResult = []
        return
      }
      this.isSearching = true
      const usecase = new SearchFAQContentUseCase({
        snapsnapGateway: this.$snapsnapGateway
      })
      try {
        this.searchedQuery = null
        this.isLoading = true
        const result = await usecase.execute(query)
        this.searchedQuery = query
        this.searchResult = result
      } catch (e) {
        // do nothing
      } finally {
        this.isSearching = false
        this.isLoading = false
      }
    },
    enableCheck(str: keyof Fields) {
      this.enableCheckFlg[str] = true
    },
    handleScroll() {
      // スマホのキーボードをtouchmove（スクロール）で閉じる
      const el = document.getElementById('searchBox') as HTMLElement
      if (el) el.blur()
    }
  }
})
